// order-helpers.ts


export const currency = (v: unknown): string => {
  const n = Number(v);
  if (!Number.isFinite(n)) return '—';
  return `$${n.toLocaleString()}`;
};

/**
 * Inyecta estilos globales de Order Assembly si aún no existen.
 * Se llama desde el contenedor al montar.
 */
export const ensureGlobalStyles = (): void => {
  if (typeof document === 'undefined') return;
  const id = 'order-assembly-styles';
  if (document.getElementById(id)) return;

  const css = `
  .order-assembly-wrapper { position:relative; background:#fff; --oa-accent:#1677ff; --oa-accent-rgb:22,119,255; --oa-accent-bg:#e6f4ff; --oa-form-bg:#fff; overflow-x:hidden; max-width:100%; box-sizing:border-box; }
  .order-assembly-wrapper *, .order-assembly-wrapper *::before, .order-assembly-wrapper *::after { box-sizing:border-box; }
  .order-assembly-wrapper .ant-table-wrapper { max-width:100% !important; overflow-x:auto !important; }
  .order-assembly-wrapper .ant-table { max-width:100% !important; }
  .order-assembly-wrapper .ant-table-content { overflow-x:auto !important; }
  .order-assembly-wrapper .ant-card { max-width:100% !important; overflow:hidden; }
  .order-assembly-wrapper .ant-collapse { max-width:100% !important; overflow:hidden; }
  .order-assembly-wrapper .ant-form { max-width:100% !important; }
  .order-assembly-wrapper .ant-input-search { max-width:100% !important; }
  .order-assembly-wrapper .oa-glass-summary { max-width:100% !important; overflow:hidden; }
  .order-assembly-theme-CPT { --oa-accent:#1677ff; --oa-accent-rgb:22,119,255; --oa-accent-bg:#e6f4ff; --oa-form-bg:#f0f6ff; }
  .order-assembly-theme-CPV { --oa-accent:#eb2f96; --oa-accent-rgb:235,47,150; --oa-accent-bg:#fff0f6; --oa-form-bg:#fff5f9; }
  .order-assembly-theme-CPE { --oa-accent:#52c41a; --oa-accent-rgb:82,196,26; --oa-accent-bg:#f6ffed; --oa-form-bg:#f2fff5; }

  .drawer-gradient-bg { background:#fff; padding:4px 2px 12px; height:100%; display:flex; flex-direction:column; overflow-x:hidden; max-width:100%; }
  .order-assembly-topbar { display:flex; justify-content:space-between; align-items:center; background:linear-gradient(135deg,#fff,rgba(var(--oa-accent-rgb),0.06)); padding:6px 12px; border:1px solid rgba(var(--oa-accent-rgb),0.28); border-radius:8px; margin-bottom:8px; }

  .oa-type-segment .ant-segmented-item { padding:2px 8px; line-height:1; }
  .oa-type-segment .ant-segmented-item-selected { background:var(--oa-accent); color:#fff; }
  .oa-type-segment .ant-segmented-item-selected span { color:#fff!important; }
  .oa-step-segment { margin:0 0 8px; }
  .oa-step-segment .ant-segmented-item { padding:2px 8px; }
  .oa-step-segment .ant-segmented-item-selected { background:var(--oa-accent)!important; color:#fff!important; box-shadow:0 6px 16px rgba(var(--oa-accent-rgb),0.28); }
  .oa-step-segment .ant-segmented-item-selected * { color:#fff!important; }
  .oa-collapse-ghost .ant-collapse-header { padding:2px 8px!important; }

  .oa-mini-label { font-size:9px; font-weight:500; text-transform:uppercase; letter-spacing:.5px; opacity:.55; }

  .oa-compact .ant-form-item { margin-bottom:10px; }
  .oa-compact .ant-input, .oa-compact .ant-select-selector, .oa-compact .ant-picker { padding:6px 10px; height:38px!important; }
  .oa-compact .ant-select-selector .ant-select-selection-search-input { height:36px!important; }
  .oa-compact .ant-input, .oa-compact .ant-select, .oa-compact .ant-picker { font-size:13px; }
  .oa-compact .ant-input-number, .oa-compact .ant-input-number-input { height:38px!important; }
  .oa-compact .ant-input-number .ant-input-number-input { padding:6px 8px; }
  .oa-compact textarea.ant-input { min-height:70px; }

  .oa-form-surface { background:var(--oa-form-bg); transition:background .25s ease; border:1px solid rgba(var(--oa-accent-rgb),0.24); border-radius:10px; padding:12px 14px 8px; max-width:1100px; width:100%; margin:0; }

  .existing-orders-table .ant-table { font-size:12px; max-width:100% !important; }
  .existing-orders-table .ant-table-content { overflow-x:auto !important; }
  .existing-orders-table .existing-order-selected td { background:var(--oa-accent-bg)!important; box-shadow: inset 0 0 0 1px var(--oa-accent); transition: background .2s ease, box-shadow .2s ease; }
  .existing-orders-table tr.existing-order-selected:hover td { background: var(--oa-accent-bg)!important; }
  .existing-orders-table .ant-table-tbody > tr.existing-order-selected > td { background: var(--oa-accent-bg)!important; }
  .existing-orders-table .ant-table-tbody > tr:not(.existing-order-selected):hover > td { cursor:pointer; background:#fafafa; }

  
  .oa-items-stack { display:flex; flex-direction:column; height:100%; gap:8px; max-width:100%; overflow-x:hidden; }
  .oa-items-stack-body { flex:1 1 auto; overflow:auto; padding-right:4px; }

  
  .oa-items-stack-cart { position:sticky; bottom:0; z-index:5; max-height:40vh; overflow:auto; }
  .oa-items-stack-cart .ant-card { margin:0; }

  
  [data-placeholder]:empty:before { content: attr(data-placeholder); color: rgba(0,0,0,0.35); pointer-events: none; display: block; }
  [data-placeholder] { min-height:30px; }

  .oa-section-accent { background:var(--oa-accent-bg); border:1px solid var(--oa-accent-bg); padding:4px 8px; border-radius:4px; font-size:12px; margin-bottom:8px; }

  .order-assembly-wrapper .ant-table-thead > tr > th {
    background: rgba(var(--oa-accent-rgb),0.08) !important;
    border-bottom: 1px solid rgba(var(--oa-accent-rgb),0.28) !important;
    color: #0f172a;
  }
  .order-assembly-wrapper .ant-table-tbody > tr:hover > td {
    background: rgba(var(--oa-accent-rgb),0.05) !important;
  }

  
  .oa-glass-summary, .oa-glass-summary .ant-card, .oa-items-stack-cart .ant-card {
    background: linear-gradient(180deg, rgba(255,255,255,0.72), rgba(250,250,252,0.6)) !important;
    background-color: rgba(255,255,255,0.78) !important;
    border: 1px solid rgba(255,255,255,0.5) !important;
    border-radius: 12px !important;
    backdrop-filter: blur(12px) saturate(130%) contrast(1.02) !important;
    -webkit-backdrop-filter: blur(12px) saturate(130%) contrast(1.02) !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .oa-glass-summary .ant-card, .oa-items-stack-cart .ant-card {
    box-shadow: 0 8px 30px rgba(16,24,40,0.08) !important;
    overflow: hidden;
  }
  .oa-glass-summary::after, .oa-items-stack-cart::after {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    border-radius: 12px;
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.6), inset 0 -1px 0 rgba(0,0,0,0.02);
  }
  `;

  const style = document.createElement('style');
  style.id = id;
  style.textContent = css;
  document.head.appendChild(style);
};
